import { render, staticRenderFns } from "./SnelStartV2.vue?vue&type=template&id=9f6fb31a&"
import script from "./SnelStartV2.vue?vue&type=script&lang=js&"
export * from "./SnelStartV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports